import header from "./drawing-a-floorplan-by-hand.jpg";
import section1 from "./zeichnunghand.jpg";
import section2 from "./floorplan-on-pc.jpg";
import section3 from "./handzeichnung.jpg";
import section4 from "./draw-floorplan-by-hand.jpg";

export { header, section1, section2, section3, section4 };

